// Espelha o enum EmployeeConsumptionStatus do backend.
const EmployeeConsumptionStatus = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    CANCELED: 'CANCELED'
};

export default EmployeeConsumptionStatus;
